import { makeStyles } from 'tss-react/mui';

export default makeStyles()({
    notFound: {
        fontWeight: 700,
        fontSize: 24,
        lineHeight: '120%',
        color: '#282D31',
        textAlign: 'center'
    },
    paginator: {
        marginTop: 32
    }
});
